import { Card, Col, Row } from 'antd'
import React, { useEffect } from 'react'
import logo1 from '../../assets/images/logo_esign.png'
import logo2 from '../../assets/images/fssai_logo.png'
import logo3 from '../../assets/images/logo_khadi.png'
import logo4 from '../../assets/images/logo_itda.jpg'
import logo5 from '../../assets/images/logo_nixi.png'
import logo6 from '../../assets/images/logo_orgi.jpg'
import logo7 from '../../assets/images/moib_logo.png'
import logo8 from '../../assets/images/DEPwD_logo.png'
import logo9 from '../../assets/images/LIC_logo.png';
import logo10 from '../../assets/images/ESIC-Color.png';
import logo11 from '../../assets/images/NABARD-Color.png';
import client_left from '../../assets/images/txn_left.png'
import client_right from '../../assets/images/txn_right.png'
import client_left_down from '../../assets/images/txn_left_down.png'
import client_right_top from '../../assets/images/svg_img/txn_right_top.svg'
import { AreaChartOutlined } from '@ant-design/icons'
import styled from '@emotion/styled'
import AOS from 'aos';
//import 'aos/dist/aos.css';

const items = [
  {
    key: '1',
    title: 'C-DAC ASA/AUA Service',
    src: logo1,
   // style: { height: '45px',   }
  },
  {
    key: '2',
    title: 'C-DAC AUA/KUA Service',
    src: logo2,
   // style: { height: '80px', width: '100px', }
  },
  {
    key: '3',
    src: logo3,
  //  style: { width: '100%',   }
  },
  {
    key: '4',
    src: logo4,
  //  style: { width: '48%',   }
  },
  {
    key: '5',
    src: logo5,
  //  style: { height: '75px', width: '100%'  }
  },
  {
    key: '6',
    src: logo6,
  //  style: { height: '80px', width: '80px',  }
  },
    {
    key: '7',
    src: logo7,
   // style: { height: '60px', width: '100%',  }
  },
   {
    key: '8',
    src: logo8,
   // style: { height: '85px', width: '100%',  }
  },
  {
    key: '9',
    src: logo9,
   // style: { height: '85px', width: '100%',  }
  },
  {
    key: '10',
    src: logo10,
   // style: { height: '85px', width: '100%',  }
  },
  {
    key: '11',
    src: logo11,
   // style: { height: '85px', width: '100%',  }
  },
]



function Clients() {
  /* 
---------- Running logo animation ----------------- 
*/

  useEffect(() => {
    // Exit early if user prefers reduced motion
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const scrollers = document.querySelectorAll<HTMLElement>(".scroller");

    scrollers.forEach((scroller) => {
      // Prevent running multiple times
      if (scroller.getAttribute("data-animated") === "true") return;

      scroller.setAttribute("data-animated", "true");

      const scrollerInner = scroller.querySelector(".scroller__inner") as HTMLElement | null;
      if (!scrollerInner) return;

      const scrollerContent = Array.from(scrollerInner.children) as HTMLElement[];
      scrollerContent.forEach((item) => {
        item.setAttribute("style", "display: flex; justify-content: space-between; gap: 1rem;");
      });

      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true) as HTMLElement;
        duplicatedItem.setAttribute("aria-hidden", "true");
        scrollerInner.appendChild(duplicatedItem);
      });
    });
    AOS.init({
        duration: 1000,
      });
  }, []);

  return (
    <section id="clients" className="clientsBlock">
            <img src={client_left} alt='image' className="corner top-left"/>
            <img src={client_right} alt='image' className="corner bottom-right"/>
            {/* <img src={client_right_top} alt='image' className="corner top-right"/> */}
            {/* <img src={client_left_down} alt='image' className="corner bottom-left"/> */}

      <div className="container-fluid">
        <div className="titleHolder">
          <h2>Our <span className="title-accent">Clients</span></h2>

        </div>

        <div className="scroller" data-speed="fast" data-direction="left">
          <div className="tag-list scroller__inner">
           <div className="client-list">
              {items.map((item, index) => (
                <div key={index} >
                  <Card style={{ textAlign: 'center', alignContent: 'center', height: '90px', width: '150px',  }} >

                    <img src={item.src} alt={`logo-${index}`} className="logo-img"  />
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Clients
